export const BarcodeMergePage = () => {
    return <>BarcodeMergePage</>
}